import React, { useState, useEffect } from "react";
import style from "./Fourth_Project.module.css";
import { fetchBen } from "../../API";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import aT from '../../Images/aT/image 3.svg';

const Fourth_Project = () => {
  const [benData, setBenData] = useState([]);
  const [stopper, setStopper] = useState(null);
  const fetchAPI = async () => {
    setBenData(await fetchBen());
  };

  useEffect(() => {
    fetchAPI();
  }, [stopper]);

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  });

  //console.log(benData);
  var proj4;
  proj4 = benData.sampleProj ? benData.sampleProj[3] : null;
  console.log(proj4);

  return (
    <section className={style.container}>
      {proj4 ? (
        <div className={style.proj}>
          <div data-aos={"fade-up"} className={style.ImageContainer}>
            <img className={style.img1} src={aT} alt="project Image" />
          </div>
          <div data-aos={"fade-up"} className={style.projectInfo}>
            <h1>{proj4.projName}</h1>
            <p>{proj4.projDesc}</p>
            <Link className={style.viewLink} to="/attendo">
              View Project
            </Link>
          </div>
        </div>
      ) : (
        console.log("no")
      )}
    </section>
  );
};

export default Fourth_Project;
